/* TIMELESS MOONLIGHT MELTS - "Which 15 melts?" picker.
   Injects a chooser into the product form on burners that include free melts.
   Choices submit as a Shopify line item property (plain text on the order line)
   so they reach the packing slip without touching stock or creating variants.
   Replaces customers typing choices into the checkout notes box.
   Injected, not themed: Milano's main-product section stays untouched. */

(function () {
  'use strict';
  var C = window.TMM_PRODUCT || {};
  if (!C.meltPicker) return;

  var TOTAL = C.meltCount || 15;
  var COLL = C.meltCollection || 'all-melts';
  var PROP = 'properties[Your ' + TOTAL + ' melts]';
  var SURPRISE = 'Surprise me - ' + TOTAL + ' chosen at random';
  var SELECTED = '__selected';

  /* Melts are tagged with plain family names - the same tags the scent finder
     links to. A melt commonly belongs to SEVERAL families, so keep them all. */
  var FAMILIES = ['Fruity', 'Fine Fragrance', 'Fresh / Laundry', 'Food & Drink',
                  'Floral & Woody', 'Autumn / Christmas'];

  var pool = null, chosen = [], mode = 'surprise', family = '', term = '';

  function el(t, c, h) { var n = document.createElement(t); if (c) n.className = c; if (h != null) n.innerHTML = h; return n; }

  function familiesOf(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
    var out = [];
    FAMILIES.forEach(function (f) { if (tags.indexOf(f.toLowerCase()) > -1) out.push(f); });
    tags.forEach(function (t) {
      if (t.indexOf('family:') === 0) {
        var v = t.slice(7).trim();
        if (v && out.indexOf(v) === -1) out.push(v);
      }
    });
    return out;
  }

  function tidy(title) {
    return title.replace(/\s*(soy\s*)?(wax\s*)?melts?\.?\s*$/i, '').trim() || title;
  }

  function fetchPool() {
    if (pool) return Promise.resolve(pool);
    var base = '/collections/' + encodeURIComponent(COLL) + '/products.json', all = [];
    function page(n) {
      return fetch(base + '?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          var it = (d && d.products) || [];
          all = all.concat(it);
          if (it.length === 250 && n < 4) return page(n + 1);
          return all;
        });
    }
    return page(1).then(function (ps) {
      pool = ps.filter(function (p) { var v = (p.variants || [])[0]; return v && v.available; })
        .map(function (p) { return { title: tidy(p.title), families: familiesOf(p) }; })
        .sort(function (a, b) { return a.title.localeCompare(b.title); });
      return pool;
    });
  }

  var root, countEl, listEl, searchEl, famEl, input, err, selChip;

  function updateSelChip() {
    if (!selChip) return;
    selChip.textContent = 'Selected (' + chosen.length + ')';
    selChip.disabled = chosen.length === 0 && family !== SELECTED;
    selChip.classList.toggle('is-empty', chosen.length === 0);
  }

  function sync() {
    input.value = (mode === 'surprise' || !chosen.length) ? SURPRISE : chosen.join(', ');
    if (mode === 'surprise') {
      countEl.textContent = 'Katie will choose for you';
      countEl.className = 'tmm-mp__count';
    } else {
      countEl.textContent = chosen.length + ' of ' + TOTAL + ' chosen';
      countEl.className = 'tmm-mp__count' + (chosen.length === TOTAL ? ' is-full' : '');
    }
    root.querySelectorAll('[data-mode]').forEach(function (b) {
      b.classList.toggle('is-on', b.dataset.mode === mode);
    });
    updateSelChip();
  }

  function toggle(title) {
    var i = chosen.indexOf(title);
    if (i > -1) { chosen.splice(i, 1); }
    else if (chosen.length < TOTAL) { chosen.push(title); }
    else {
      err.textContent = 'That is all ' + TOTAL + '. Remove one to swap it out.';
      setTimeout(function () { err.textContent = ''; }, 2600);
      return;
    }
    render(); sync();
  }

  function render() {
    if (!pool) return;
    var t = term.toLowerCase();
    var items = pool.filter(function (p) {
      if (family === SELECTED) {
        if (chosen.indexOf(p.title) === -1) return false;
      } else if (family && p.families.indexOf(family) === -1) {
        return false;
      }
      if (t && p.title.toLowerCase().indexOf(t) === -1) return false;
      return true;
    });

    listEl.innerHTML = '';
    if (!items.length) {
      var msg = family === SELECTED
        ? 'Nothing chosen yet. Pick from All scents or a fragrance family.'
        : 'No scents match that.';
      listEl.appendChild(el('p', 'tmm-mp__empty', msg));
      return;
    }
    items.slice(0, 400).forEach(function (p) {
      var on = chosen.indexOf(p.title) > -1;
      var b = el('button', 'tmm-mp__chip' + (on ? ' is-on' : ''), p.title);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(on));
      b.title = on ? 'Tap to remove' : 'Tap to add';
      b.addEventListener('click', function (e) { e.preventDefault(); toggle(p.title); });
      listEl.appendChild(b);
    });
  }

  function allFamilies() {
    var seen = {}, out = [];
    pool.forEach(function (p) {
      p.families.forEach(function (f) { if (!seen[f]) { seen[f] = 1; out.push(f); } });
    });
    return out.sort();
  }

  function buildFilters() {
    famEl.innerHTML = '';
    famEl.style.display = '';

    function chip(label, value, cls) {
      var b = el('button', 'tmm-mp__fam' + (cls ? ' ' + cls : '') + (value === family ? ' is-on' : ''), label);
      b.type = 'button';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        family = value;
        famEl.querySelectorAll('.tmm-mp__fam').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        render(); updateSelChip();
      });
      return b;
    }

    famEl.appendChild(chip('All scents', ''));

    /* "Selected" gathers everything chosen in one place, so removing a scent
       never means hunting for it again in a list of 300. */
    selChip = chip('Selected (0)', SELECTED, 'tmm-mp__fam--sel');
    famEl.appendChild(selChip);

    allFamilies().forEach(function (f) { famEl.appendChild(chip(f, f)); });
    updateSelChip();
  }

  function loadThen(fn) {
    root.classList.add('is-loading');
    fetchPool().then(function () {
      root.classList.remove('is-loading');
      buildFilters(); fn();
    }).catch(function () {
      root.classList.remove('is-loading');
      err.textContent = 'Could not load the scent list. You can still order and tell us your choices by email.';
    });
  }

  function setMode(m) {
    mode = m;
    root.classList.toggle('is-open', m === 'choose');
    if (m === 'surprise') { chosen = []; sync(); return; }
    chosen = []; family = ''; term = '';
    if (searchEl) searchEl.value = '';
    loadThen(function () { render(); sync(); });
  }

  function build(form) {
    root = el('div', 'tmm-mp');

    var head = el('div', 'tmm-mp__head');
    head.appendChild(el('span', 'tmm-mp__title', 'Which ' + TOTAL + ' melts would you like?'));
    countEl = el('span', 'tmm-mp__count', 'Katie will choose for you');
    head.appendChild(countEl);
    root.appendChild(head);

    var modes = el('div', 'tmm-mp__modes');
    [['surprise', 'Surprise me'], ['choose', 'Choose my own']].forEach(function (m) {
      var b = el('button', 'tmm-mp__mode', m[1]);
      b.type = 'button'; b.dataset.mode = m[0];
      b.addEventListener('click', function (e) { e.preventDefault(); setMode(m[0]); });
      modes.appendChild(b);
    });
    root.appendChild(modes);

    var panel = el('div', 'tmm-mp__panel');
    var tools = el('div', 'tmm-mp__tools');
    searchEl = el('input', 'tmm-mp__search');
    searchEl.type = 'search';
    searchEl.placeholder = 'Search scents...';
    searchEl.addEventListener('input', function () { term = searchEl.value; render(); });
    searchEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    tools.appendChild(searchEl);
    panel.appendChild(tools);

    famEl = el('div', 'tmm-mp__families');
    panel.appendChild(famEl);

    listEl = el('div', 'tmm-mp__list');
    panel.appendChild(listEl);
    root.appendChild(panel);

    err = el('p', 'tmm-mp__err', '');
    root.appendChild(err);

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = PROP;
    input.value = SURPRISE;
    root.appendChild(input);

    var anchor = form.querySelector('.product-form__buttons, [class*="buy-buttons"], button[name="add"], [type="submit"]');
    if (anchor) {
      var host = anchor.closest('.product-form__buttons') || anchor.parentElement;
      host.parentElement.insertBefore(root, host);
    } else {
      form.appendChild(root);
    }
    sync();
  }

  function init() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.tmmMp === 'on') return;
    form.dataset.tmmMp = 'on';
    build(form);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
